import { OrderType, useSearchUsersByAppRoleFiltersLazyQuery } from '@exam-management/graphql';
import { useAuth } from '@shared/auth';
import { FormSearchSelection, PersonOutlinedIcon } from '@shared/components';
import { useMemo, useState } from 'react';

interface QSetReviewFormUserSelectionProps {
  name: string;
  initialInputValue?: string;
}

export default function QSetReviewFormUserSelection(
  props: Readonly<QSetReviewFormUserSelectionProps>,
) {
  const { name, initialInputValue = '' } = props;

  const { userProfile } = useAuth();

  const [inputValue, setInputValue] = useState<string | null>(initialInputValue);

  const [searchUser, { data: userListData, loading: isSearchingUserList }] =
    useSearchUsersByAppRoleFiltersLazyQuery();

  const userOptions = useMemo(() => {
    return !isSearchingUserList && userListData
      ? userListData.UsBoSearchUsersWithAppRoleFilters.users
          .map((user) => ({
            label: `${user.firstname} ${user.lastname}`,
            value: user.id,
          }))
          .filter((user) => user.value !== userProfile?.id)
      : [];
  }, [userListData]);

  return (
    <FormSearchSelection
      name={name}
      label='Assignee'
      mode='fetch-debounce'
      inputValue={inputValue ?? ''}
      options={userOptions}
      placeholder='กรุณาเลือก Assignee'
      loading={isSearchingUserList}
      required
      onSearch={(inputValue) => {
        const [firstname, lastname] = inputValue?.trim().split(' ') ?? [];
        searchUser({
          variables: {
            appRoleNames: [],
            order: {
              type: OrderType.Asc,
              field: 'firstname',
            },
            paging: {
              currentPage: 0,
              pageSize: 100,
            },
            search: {
              firstname: firstname,
              lastname: lastname,
              email: '',
              status: '',
            },
          },
          fetchPolicy: 'network-only',
        });
      }}
      onChange={(_, option) => {
        setInputValue(option?.label ?? '');
      }}
      onInputChange={(_, value) => {
        setInputValue(value);
      }}
      slotProps={{
        input: {
          startAdornment: (
            <PersonOutlinedIcon
              sx={(theme) => ({
                width: 20,
                height: 20,
                mr: theme.spacing(2),
                color: theme.palette.grey[500],
              })}
            />
          ),
        },
      }}
    />
  );
}
